import React from 'react';
import { useMarketingEmbedded } from '../hooks/useMarketingEmbedded';
import MarketingPageHeader from '../components/marketing/MarketingPageHeader';
import PortalBackground from '../components/PortalBackground';

const Strategy = ({ embedded: embeddedProp }) => {
  const embedded = useMarketingEmbedded(embeddedProp);
  return (
    <div className={embedded ? '' : 'relative min-h-screen p-6'}>
      {!embedded && <PortalBackground />}
      <div className={embedded ? '' : 'relative'}>
      {!embedded && <MarketingPageHeader title="Marketing Strategy" />}
      {embedded && <h1 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-white mb-8 text-center">Marketing Strategy</h1>}
      <div className="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-sm p-6">
        <div className="space-y-6">
          <div>
            <h2 className="text-xl font-semibold text-gray-700 mb-4">Strategic Planning</h2>
            <p className="text-gray-600">
              Develop and track your marketing strategy to achieve your business goals and objectives.
            </p>
          </div>
          
          {/* Content will be added here */}
          <div className="text-gray-500 italic">
            Content coming soon...
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default Strategy; 